import { useSessionData } from '@confluence/session-data';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { useIsWhiteboardFeatureEnabled } from '@confluence/whiteboard-utils';
import { useIsAllowedToCreateWhiteboard } from '@confluence/content-types-utils';

export const useIsEligibleCreateNewWhiteboard = () => {
	const { edition } = useSessionData();

	const { isWhiteboardFeatureEnabled } = useIsWhiteboardFeatureEnabled();
	const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');

	const isAllowedToCreateWhiteboard = useIsAllowedToCreateWhiteboard();

	return {
		isEligibleCreateNewWhiteboard:
			edition !== ConfluenceEdition.FREE && isWhiteboardsEnabled && isAllowedToCreateWhiteboard,
	};
};
